import { Component } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ClientListComponent } from '../components/client-list/client-list.component';
import { CreditOrderModalComponent } from '../components/credit-order-modal/credit-order-modal.component';
import { DeleteCreditModalComponent } from '../components/delete-credit-modal/delete-credit-modal.component';
import { SearchClientComponent } from '../components/search-client/search-clients.component';
import { Client } from '../models/client';

@Component({
  selector: 'admin-manage-clients-container',
  standalone: true,
  imports: [MatDialogModule, SearchClientComponent, ClientListComponent],
  templateUrl: './manage-clients.container.html',
  styleUrls: ['./manage-clients.container.scss'],
})
export class ManageClientsContainer {
  clients: Client[] = [
    {
      code: 'F90045',
      nom: 'Unofi',
      modePaiement: 'SEPA',
      nbreUtilisateur: '15',
      soldeCredits: 150,
      reappoAuto: 100,
      dateDerniereCommande: '15/03/2024',
    },
    {
      code: 'F99000',
      nom: 'Cofaris',
      modePaiement: 'SEPA',
      nbreUtilisateur: '8',
      soldeCredits: 10,
      dateDerniereCommande: '2021-06-01',
    },
    {
      code: 'C3',
      nom: 'Client 3',
      modePaiement: 'Virement',
      nbreUtilisateur: '5',
      soldeCredits: 1000,
      reappoAuto: 10,
      dateDerniereCommande: '2021-06-01',
    },
    {
      code: 'C4',
      nom: 'Client 4',
      modePaiement: 'Virement',
      nbreUtilisateur: '5',
      soldeCredits: 1000,
      reappoAuto: 10,
      dateDerniereCommande: '2021-06-01',
    },
    {
      code: 'C5',
      nom: 'Client 5',
      modePaiement: 'Virement',
      nbreUtilisateur: '5',
      soldeCredits: 1000,
      reappoAuto: 10,
      dateDerniereCommande: '2021-06-01',
    },
  ];

  constructor(public dialog: MatDialog) {}

  onCreditOrder(): void {
    const dialogRef = this.dialog.open(CreditOrderModalComponent, {
      data: {},
      minWidth: '500px',
    });

    dialogRef.afterClosed().subscribe(() => {});
  }

  onDeleteCredit(): void {
    const dialogRef = this.dialog.open(DeleteCreditModalComponent, {
      data: {},
      minWidth: '300px',
    });

    dialogRef.afterClosed().subscribe(() => {});
  }
}
